import { TreeviewLinkType } from 'sigma-mappings';

const INSTALLATION_NODE_TYPE = 'installation';

// Nível "Tipo do ativo" da hierarquia (Empresa > Regional > Instalação >
// TipoAtivo > Ativo, ver AssetTreeviewItem em sigma-mappings) — mapeado pelo
// próprio pacote para essa string fixa (AssetTreeviewItemType.ASSET_TYPE).
const ASSET_TYPE_NODE_TYPE = 'asset-type';
// `node.name` desse nível vem do backend já traduzido para o idioma da
// requisição ("Transformador"/"Transformer"...), o mesmo texto de
// enums.asset-info.asset-type.transformer nos arquivos de i18n — quem chama
// passa esse texto no idioma atual (`transformerTypeName`). Comparado
// normalizado para não quebrar por acento/caixa vindos de fontes diferentes.
const DEFAULT_TRANSFORMER_ASSET_TYPE_NAME = 'transformador';

function isAssetNode(node) {
  return node.clickType === TreeviewLinkType.LINK;
}

/*
 * O CMA só sabe exibir transformadores (ver CmaAsset3dView.vue/
 * transformer3dModels.js — não há modelo 3D nem cards para disjuntor ou
 * seccionadora): a árvore some com os outros tipos de ativo ANTES de virar
 * `assetTree` (filtro do menu lateral) e `assets` (flattenAssetNodes, fonte
 * do rodízio automático — ver advanceRotation em CmaDashboard.vue), então os
 * dois já saem restritos a transformador sem precisar de dois filtros
 * separados.
 *
 * Poda pelo nó "TipoAtivo" (não pelo "Ativo" folha): é ali que o backend já
 * agrupa por tipo, então um filtro de nome só nesse nível — mantendo o
 * ramo inteiro quando bate — é o suficiente. Ramos que ficam sem nenhum
 * "TipoAtivo" de transformador (ex.: instalação só com disjuntores) somem
 * também, em vez de aparecer vazios no menu.
 */
export function filterTransformerAssets(
  nodes,
  transformerTypeName = DEFAULT_TRANSFORMER_ASSET_TYPE_NAME,
) {
  const expectedName = String(transformerTypeName).trim().toLowerCase();

  return (nodes || []).reduce((filtered, node) => {
    if (node.type === ASSET_TYPE_NODE_TYPE) {
      if ((node.name || '').trim().toLowerCase() === expectedName) {
        filtered.push(node);
      }
      return filtered;
    }

    const children = filterTransformerAssets(node.children, transformerTypeName);
    if (isAssetNode(node) || children.length) {
      filtered.push({ ...node, children });
    }
    return filtered;
  }, []);
}

export function flattenAssetNodes(nodes, installationName = '') {
  return (nodes || []).reduce((assets, node) => {
    const currentInstallationName = node.type === INSTALLATION_NODE_TYPE
      ? node.name
      : installationName;

    if (isAssetNode(node)) {
      assets.push({
        id: node.id,
        name: node.name,
        installation: { id: node.installationId, name: currentInstallationName },
      });
    }

    return assets.concat(flattenAssetNodes(node.children, currentInstallationName));
  }, []);
}

export function findFirstAssetNode(nodes) {
  for (let i = 0; i < (nodes || []).length; i += 1) {
    const node = nodes[i];
    if (isAssetNode(node)) return node;
    const found = findFirstAssetNode(node.children);
    if (found) return found;
  }
  return null;
}
